import React from "react";
import { Page } from "../../../activities/AppPage";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { INFO_CIRCLE_ICON } from "../../../utils/svgs_new";
import { AppIcon } from "../../Generic/AppIcon";
import ScaffoldTitle from "../../Scaffold/components/ScaffoldTitle";
import Scaffold from "../../Scaffold/Scaffold";

type Props = {
  onRequestNavigate: (page: Page) => void;
  onClickGoBack: () => void;
};

export default function RaffleHeader(props: Props) {
  return (
    <Scaffold.HeaderContent>
      <Scaffold.HeaderMainAction onClickGoBack={props.onClickGoBack} />
      <Scaffold.HeaderTitle>
        <ScaffoldTitle label={translate(STRINGS.MEDFLYT_RAFFLE)} />
      </Scaffold.HeaderTitle>
      <Scaffold.HeaderActions>
        <AppIcon
          icon={INFO_CIRCLE_ICON}
          size={16}
          fill="#000"
          onClick={() => props.onRequestNavigate({ type: "RaffleInfo" })}
          style={{ animation: "slideFadeIn 0.3s ease 200ms backwards" }}
        />
      </Scaffold.HeaderActions>
    </Scaffold.HeaderContent>
  );
}
